export default {
  label: 'Alterar domínio'
}
